var React = require('react');

function ArrowDownRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 11L11 11L11 1","stroke":"white","strokeWidth":"1.6","key":0}),React.createElement("path",{"d":"M11 11L1 1","stroke":"white","strokeWidth":"1.6","key":1})]);
}

ArrowDownRight.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrowDownRight;

ArrowDownRight.default = ArrowDownRight;
